import React from 'react';
import Hero from '../components/Hero';
import EducationalPrograms from '../components/EducationalPrograms';
import About from '../components/About';
import Counter from '../components/Counter';
import Benefits from '../components/Benefits';
import HowItWorks from '../components/HowItWorks';
import Blog from '../components/Blog';
import Download from '../components/Download';

const SproutlyPage: React.FC = () => {
  return (
    <div className="main-wrapper">
      <Hero />
      <EducationalPrograms />
      <About />
      <Counter />
      <Benefits />
      <HowItWorks />
      <Download />
      <Blog />
    </div>
  );
};

export default SproutlyPage;
